<payee-popup
  [heading]="'CREDITS.PAYMENT.TRANSFER_INSTRUCTIONS.TITLE' | translate"
  [description]="'CREDITS.PAYMENT.TRANSFER_INSTRUCTIONS.DESCRIPTION' | translate"
>
  <form [formGroup]="form">
    <payee-form-field width="max">
      <span payee-label>
        {{ "CREDITS.PAYMENT.TRANSFER_INSTRUCTIONS.AMOUNT_LABEL" | translate }}
      </span>
      <span
        payee-suffix
        style="margin-right: 30px"
      >
        {{ data.currency_iso }}
      </span>
      <payee-copy-form-field formControlName="transfer_amount"></payee-copy-form-field>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>
        {{ "CREDITS.PAYMENT.TRANSFER_INSTRUCTIONS.BENEFICIARY_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="account_holder_name"></payee-copy-form-field>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>
        {{ "CREDITS.PAYMENT.TRANSFER_INSTRUCTIONS.ACCOUNT_NUMBER_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="account_number"></payee-copy-form-field>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>
        {{ "CREDITS.PAYMENT.TRANSFER_INSTRUCTIONS.REFERENCE_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="credit_transfer_id"></payee-copy-form-field>
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      mat-dialog-close
    >
      <div class="close-button-content">
        <span>
          {{ "CREDITS.PAYMENT.TRANSFER_INSTRUCTIONS.BUTTON_LABEL" | translate }}
        </span>
        <payee-icon name="arrow-right-white"></payee-icon>
      </div>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate></ng-template>
</payee-popup>
